import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Modal, Select} from 'antd';
import {message, Upload} from 'antd';
import axios from "axios";
import {useParams} from "react-router-dom";
import {toast} from "react-toastify";
import {tr} from "date-fns/locale";
import {CAM_PATH} from "../../../components/const";

const {Dragger} = Upload;
const EquipmentMaintenance = () => {
    let params = useParams()
    const [pass, setPass] = useState("")
    const [isModalOpen, setiIModalOpen] = useState(false)
    const [isModalOpen2, setiIModalOpen2] = useState(false)
    const days = [
        {
            label: "Monday",
            value: 1
        },
        {
            label: "Tuesday",
            value: 2
        },
        {
            label: "Wednesday",
            value: 3
        },
        {
            label: "Thursday",
            value: 4
        },
        {
            label: "Friday",
            value: 5
        },
        {
            label: "Saturday",
            value: 6
        },
        {
            label: "Sunday",
            value: 0
        },

    ]
    const [sendData, setSendData] = useState({})
    const onReset = () => {
        if (pass === "") {
            toast.error("Please enter password")
        } else {
            axios.post(CAM_PATH + "device/" + params.id + "/equipment/restart", {password: pass}, {
                auth: {
                    username: 'admin',
                    password: "ping1234"
                }
            })
                .then(res => {
                    toast.success("Success")
                    setiIModalOpen2(false)
                })
        }
    }
    const onFormat = () => {
        if (pass === "") {
            toast.error("Please enter password")
        } else {
            axios.post(CAM_PATH + "device/" + params.id + "/equipment/diskFormat", {password: pass}, {
                auth: {
                    username: 'admin',
                    password: "ping1234"
                }
            })
                .then(res => {
                    toast.success("Success")
                    setiIModalOpen(false)
                })
        }
    }
    const onChange = () => {

    }
    const Reboot = () => {
        axios.post(CAM_PATH + "device/" + params.id + "/equipment/setRebootConf", sendData, {
            auth: {
                username: 'admin',
                password: "ping1234"
            }
        })
            .then(res =>{
                toast.success("Success")
                setSendData({mode: null, day_week: null, minute: null, hour: null, password :null})
            })
    }
    useEffect(() => {
        setPass("")
    }, [isModalOpen, isModalOpen2])
    return (
        <div className="equipment-maintenance main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Settings</span>
            </div>

            <div className="camera-config-content">
                <h5 className="text-white mb-4"> Equipment Maintenance</h5>
                <div className="row  align-items-center">
                    <div className="col-md-2 text-end cmcf-title">Reset the device</div>
                    <div className="col-md-8">
                        <Checkbox onChange={onChange} className="mr-16">Network reset</Checkbox>
                        <Checkbox onChange={onChange}>User data reset</Checkbox>
                    </div>


                </div>
                <div className="row align-items-center mt-3 ">
                    <div className="col-md-2 text-end cmcf-title">Format the disk</div>
                    <div className="col-md-8">
                        <button onClick={() => setiIModalOpen(true)}
                                style={{width: "32px"}}
                                className="btn btn-danger p-2 border-cycle  d-flex align-items-center justify-content-center">
                            <img className="w-100" src="/icon/filecancel.png" alt="..."/>
                        </button>
                    </div>
                </div>
                <div className="row align-items-center mt-3">
                    <div className="col-md-2 text-end cmcf-title">Restart the device</div>
                    <div className="col-md-8">
                        <button style={{width: "32px"}}
                                onClick={() => setiIModalOpen2(true)}
                                className="btn btn-danger p-2 border-cycle d-flex align-items-center justify-content-center">
                            <img className="w-100" src="/icon/powerbutton.png" alt="..."/>
                        </button>
                    </div>

                </div>
            </div>

            <div className="camera-config-content cam-add-modal">
                <h5 className="text-white mb-4">Timed Restart</h5>
                <div className="col-md-4">
                    <div className="inputs-box col-4 d-flex align-items-center">
                        <label className="font-family-medium text-white d-block">Mode</label>

                    </div>
                    <div className="d-flex w-100 mt-2 tabs-content-filter">
                        <Select
                            placeholder="Select"
                            optionFilterProp="children"
                            className="w-100"
                            onChange={(e) => setSendData({...sendData,mode: e})}
                        >
                            <option value="0">Disabled</option>
                            <option value="1">Day</option>
                            <option value="2">Week</option>
                        </Select>

                    </div>
                    <div className="inputs-box col-4 d-flex align-items-center mt-3 ">
                        <label className="font-family-medium text-white d-block  ">day_week</label>

                    </div>
                    <div className="inputs-box mb-2 tabs-content-filter">
                        <Select
                            // mode="multiple"
                            placeholder="Поиск, чтобы выбрать"
                            optionFilterProp="children"
                            className="w-100  "
                            onChange={(e) => setSendData({...sendData,day_week: e})}
                            options={days}
                        />
                    </div>
                    <div className="inputs-box text-white">
                        <label className="font-family-medium mt-2 text-white"> hour and minute </label>
                        <input
                            onChange={(e) => setSendData({...sendData,hour: e.target.value?.slice(0, 2),minute: e.target.value?.slice(3, 5)})}
                            type="time"
                            className="d-block w-100 mb-3 mt-2"/>
                    </div>
                    <div className="inputs-box text-white">
                        <label className="font-family-medium mt-2 text-white"> password </label>
                        <input
                            onChange={(e) => setSendData({...sendData,password: e.target.value})}
                            type="text"
                            className="d-block w-100 mb-3 mt-2"/>
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="add-btn mt-3 p-2" onClick={Reboot}>Save</button>
                    </div>
                </div>
            </div>
            <div className="camera-config-content">
                <h5 className="text-white mb-4">Timed Restart</h5>
                <div className="col-md-4">
                    <Dragger>
                        <p className="ant-upload-drag-icon">
                            <img src="/icon/uploadbigarrow.png" alt="upload"/>
                        </p>
                        <p className="ant-upload-hint cmcf-title text-white">
                            Drag the file here, or Click on the upload
                            Only IMG files can be uploaded
                        </p>
                    </Dragger>
                    <button className="btn btn-primary mt-2 w-100">Start upgrade</button>
                </div>
            </div>


            {
                isModalOpen
                    ?
                    <Modal title="Внимание!"
                           open={isModalOpen}
                           onCancel={() => setiIModalOpen(false)}
                           footer={[
                               <Button key="submit" type="default" onClick={(() => setiIModalOpen(false))}>
                                   Отменить
                               </Button>,
                               <Button key="submit" type="primary" className="my-red-canc" onClick={onFormat}>
                                   Да
                               </Button>
                           ]}
                    >

                        <div className="inputs-box">
                            <label className="font-family-medium mt-2"> Введите пароль камеры для действия </label>
                            <input
                                value={pass}
                                onChange={(e) => setPass(e.target.value)}
                                type="text"
                                className="d-block w-100 mb-3 mt-2"/>
                        </div>
                    </Modal>
                    :
                    ""
            }

            {
                isModalOpen2
                    ?
                    <Modal title="Внимание!"
                           open={isModalOpen2}
                           onCancel={() => setiIModalOpen2(false)}
                           footer={[
                               <Button key="submit" type="default" onClick={() => setiIModalOpen2(false)}>
                                   Отменить
                               </Button>,
                               <Button key="submit" type="primary" onClick={onReset}>
                                   Да
                               </Button>
                           ]}
                    >
                        <div className="inputs-box">
                            <label className="font-family-medium mt-2"> Введите пароль камеры для действия </label>
                            <input
                                value={pass}
                                onChange={(e) => setPass(e.target.value)}
                                type="text"
                                className="d-block w-100 mb-3 mt-2"/>
                        </div>
                    </Modal>
                    :
                    ""
            }

        </div>
    );
};

export default EquipmentMaintenance;